import { render, staticRenderFns } from "./PulmotilAssumptionReport.vue?vue&type=template&id=1d23dc9f&scoped=true&"
import script from "./PulmotilAssumptionReport.vue?vue&type=script&lang=ts&"
export * from "./PulmotilAssumptionReport.vue?vue&type=script&lang=ts&"
import style0 from "./PulmotilAssumptionReport.vue?vue&type=style&index=0&id=1d23dc9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d23dc9f",
  null
  
)

export default component.exports